<vs-app-page class="!pt-0 !px-0 [&_.vs-app-page-header]:!px-1" [config]="pageConfig$ | async">
  <ws-json-preview
    *ngIf="sourceData$ | async as src"
    class="mb-4"
    [title]="src.title"
    [json]="src.data"
  ></ws-json-preview>

  <ws-json-preview
    *ngIf="commandData$ | async as cmd"
    class="mb-4"
    [title]="cmd.title"
    [json]="cmd.data"
  ></ws-json-preview>

  <ws-json-preview
    *ngIf="resultData$ | async as res"
    class="mb-4"
    [title]="res.title"
    [json]="res.data"
  ></ws-json-preview>
</vs-app-page>
